import classNames from 'classnames';

import styles from './_index.module.scss';

export interface FlexProps extends React.HTMLAttributes<HTMLElement> {
  direction?: 'column' | 'column-reverse' | 'row' | 'row-reverse';
  gap?: 'x-small' | 'small' | 'medium' | 'large' | 'x-large';
}

const Flex = <T extends React.ElementType>({
  as,
  className,
  direction = 'row',
  gap = 'medium',
  ...props
}: FlexProps & PolymorphicProps<T>) => {
  const Component = as || 'div';
  return (
    <Component
      className={classNames(styles[`flex-${direction}`], styles[`is-${gap}`], className)}
      {...props}
    />
  );
};

Flex.Column = <T extends React.ElementType>(
  args: Omit<FlexProps, 'direction'> & PolymorphicProps<T>
) => <Flex direction="column" {...args} />;
Flex.Row = <T extends React.ElementType>(
  args: Omit<FlexProps, 'direction'> & PolymorphicProps<T>
) => <Flex direction="row" {...args} />;

export default Flex;
